// extracted by mini-css-extract-plugin
export var hidden = "_vc-0";